import { STORE_NAME } from '../config'

const milestones = [
  {
    era: 'Foundation',
    title: 'Trading begins in the Benelux',
    text: `Alpha Import & Export B.V. is established in Bree, Belgium — at the crossroads of European logistics — to connect buyers with overseas producers directly.`
  },
  {
    era: 'Building the network',
    title: 'Direct producer relationships',
    text: `At ${STORE_NAME}, we sign sourcing agreements with growers, mills and manufacturers, replacing brokered supply with direct, traceable relationships at origin.`
  },
  {
    era: 'Scaling up',
    title: 'Bulk and containerised freight',
    text: 'Logistics capability expands to full container loads, flexitanks, IBCs and palletised deliveries — with export documentation handled entirely in-house.'
  },
  {
    era: 'Digital shift',
    title: 'Online catalog and quote requests',
    text: 'We launch this platform so buyers can browse live stock, compare pricing and request quotes in minutes instead of waiting days for email replies.'
  },
  {
    era: 'Today',
    title: 'Serving retail and wholesale buyers',
    text: `${STORE_NAME} now serves retail and wholesale buyers across Europe, Africa, the Middle East and Asia — as a single accountable partner from spec to delivery.`
  }
]

export function JourneyTimeline() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <span className="mb-3 inline-block rounded-full border border-brand-gold/40 bg-brand-gold/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-navy">
          Our history
        </span>
        <h2 className="heading-accent font-display text-2xl font-bold text-brand-ink sm:text-3xl">
          The {STORE_NAME} journey so far
        </h2>
        <p className="mt-4 max-w-2xl text-brand-slate">
          From a Belgian trading desk to a multi-continent sourcing network — here is how {STORE_NAME} has grown with its buyers.
        </p>
        <div className="mt-12">
          <ol className="relative border-l-2 border-brand-gold/30 pl-8">
            {milestones.map((m) => (
              <li key={m.era} className="relative mb-10 last:mb-0">
                <span className="absolute -left-[41px] flex h-5 w-5 items-center justify-center rounded-full border-2 border-brand-gold bg-white">
                  <span className="h-2 w-2 rounded-full bg-brand-gold" />
                </span>
                <span className="inline-block rounded-full bg-brand-gold/15 px-3 py-0.5 text-xs font-bold uppercase tracking-wider text-brand-navy">
                  {m.era}
                </span>
                <h3 className="mt-3 font-display text-xl font-semibold text-brand-ink">{m.title}</h3>
                <p className="mt-2 max-w-2xl leading-relaxed text-brand-slate">{m.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
